import Cookies from 'js-cookie';
import { get } from 'lodash';

import ACTIONS from 'state/constants';
import { getCurrentDomain } from 'utils/Url';

const setCookies = cookies => {
  cookies.forEach(cookie => {
    const { name, value, maxAge } = cookie;
    const today = new Date();
    const expires = maxAge ? today.setTime(maxAge) : null; // if maxAge is not provided, cookie will expire at end of session
    const domain = getCurrentDomain();

    Cookies.remove(name); // remove existing cookie
    Cookies.set(name, value, { domain, expires }); // refresh expiration timer
  });
};

const setDynamicYieldCookies = store => next => action => {
  next(action);

  if (action.type === ACTIONS.FETCH_PERSONALIZATIONS_SUCCESS) {
    const state = store.getState();
    const cookies = get(state, ['personalizations', 'cookies'], []);
    setCookies(cookies);
  }
};

export default setDynamicYieldCookies;
